import logoWhite from "assets/images/logo/logo.jpg";
import { Fragment } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, Image, P } from "../../../AbstractElements";
import logoDark from "../../../assets/images/logo/logo_dark.png";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { FORM_ERROR_MESSAGES, validator } from "Constant";
import axiosInstance from "hook/axiosInstance";

const ForgetPwd = ({ logoClassMain }) => {
  const { control, handleSubmit } = useForm();
  const navigate = useNavigate();

  const onSubmit = async (values) => {
    try {
      const result = await axiosInstance.post("user/forget-password", values);
      if (result.data) {
        toast.error("Thành công");
        navigate("/");
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || "Có lỗi");
    }
  };
  return (
    <Fragment>
      <section>
        <Container className="p-0 login-page" fluid={true}>
          <Row className="m-0">
            <Col className="p-0">
              <div className="login-card">
                <div>
                  <div>
                    <Link
                      className={`logo ${logoClassMain ? logoClassMain : ""}`}
                      to={"/"}
                    >
                      <Image
                        attrImage={{
                          className: "img-fluid for-light w-20 h-20",
                          src: logoWhite,
                          alt: "looginpage",
                        }}
                      />
                      <Image
                        attrImage={{
                          className: "img-fluid for-dark",
                          src: logoDark,
                          alt: "looginpage",
                        }}
                      />
                    </Link>
                  </div>
                  <div className="login-main">
                    <Form className="theme-form login-form">
                      <H4>Lấy lại mật khẩu</H4>
                      <FormGroup className="position-relative">
                        <Label className="col-form-label m-0">
                          Tên người dùng
                        </Label>
                        <div className="position-relative">
                          <Controller
                            control={control}
                            name="username"
                            rules={{
                              required: FORM_ERROR_MESSAGES.REQUIRED,
                            }}
                            render={({ field, fieldState }) => (
                              <>
                                <Input
                                  {...field}
                                  className="form-control"
                                  required
                                />
                                {fieldState.error && (
                                  <span className="text-red-500">
                                    {fieldState.error.message}
                                  </span>
                                )}
                              </>
                            )}
                          />
                        </div>
                      </FormGroup>
                      <FormGroup>
                        <Label className="col-form-label m-0">Email</Label>
                        <Controller
                          control={control}
                          name="email"
                          rules={{
                            required: FORM_ERROR_MESSAGES.REQUIRED,
                            validate: validator.email,
                          }}
                          render={({ field, fieldState }) => (
                            <>
                              <Input
                                {...field}
                                className="form-control"
                                required
                              />
                              {fieldState.error && (
                                <span className="text-red-500">
                                  {fieldState.error.message}
                                </span>
                              )}
                            </>
                          )}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Btn
                          attrBtn={{
                            color: "primary",
                            className: "btn d-block w-100",
                            type: "submit",
                            onClick: handleSubmit(onSubmit),
                          }}
                        >
                          Hoàn thành
                        </Btn>
                      </FormGroup>
                      <P attrPara={{ className: "text-start" }}>
                        Đã có mật khẩu?
                        <Link className="ms-2" to={"/login"}>
                          Đăng nhập
                        </Link>
                      </P>
                    </Form>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Fragment>
  );
};

export default ForgetPwd;
